import {
  TextInput,
  ImageInput,
  TextAreaInput,
  DateTimeInput,
  FactureInput,
  BooleanInput,
  UrgenceSelectInput,
  ThemeTypeInput,
  TimePickerInput,
  TypeInput,
  DevisInput,
  GradeInput,
  ReferenceInput,
} from '../../../components/common/Inputs'

const HandlingInput = ({
  input,
  record,
  setPayload,
  payload,
  setRefresh,
  setErrors,
  errors,
}) => {
  if (!input) return null
  if (input.type == 'Text' || input.type === 'Number') {
    return (
      <TextInput
        {...input}
        record={record}
        setPayload={setPayload}
        payload={payload}
        setErrors={setErrors}
        errors={errors}
      />
    )
  }
  if (input.type === 'Image') {
    return (
      <ImageInput
        {...input}
        record={record}
        setPayload={setPayload}
        payload={payload}
        previews={true}
        setRefresh={setRefresh}
        setErrors={setErrors}
        errors={errors}
      />
    )
  }
  if (input.type === 'ImageFireForget') {
    return (
      <ImageInput
        {...input}
        record={record}
        setPayload={setPayload}
        payload={payload}
        previews={false}
        setErrors={setErrors}
        errors={errors}
      />
    )
  }
  if (input.type === 'Devis') {
    return (
      <DevisInput
        {...input}
        record={record}
        setPayload={setPayload}
        payload={payload}
        setRefresh={setRefresh}
        setErrors={setErrors}
        errors={errors}
      />
    )
  }
  if (input.type === 'Facture') {
    return (
      <FactureInput
        {...input}
        record={record}
        setPayload={setPayload}
        payload={payload}
        setRefresh={setRefresh}
        setErrors={setErrors}
        errors={errors}
      />
    )
  }
  if (input.type === 'Textarea') {
    return (
      <TextAreaInput
        {...input}
        record={record}
        setPayload={setPayload}
        payload={payload}
        setErrors={setErrors}
        errors={errors}
      />
    )
  }
  if (input.type === 'Datetime') {
    return (
      <DateTimeInput
        {...input}
        record={record}
        setPayload={setPayload}
        payload={payload}
        setErrors={setErrors}
        errors={errors}
      />
    )
  }

  if (input.type === 'Boolean') {
    return (
      <BooleanInput
        {...input}
        record={record}
        setPayload={setPayload}
        payload={payload}
        setErrors={setErrors}
        errors={errors}
      />
    )
  }
  if (input.type === 'PrestaReference') {
    return (
      <ReferenceInput
        {...input}
        record={record}
        setPayload={setPayload}
        payload={payload}
        optionLabel="name"
        optionValue="id"
        reference="prestas"
        setErrors={setErrors}
        errors={errors}
      />
    )
  }
  if (input.type === 'UserReference') {
    return (
      <ReferenceInput
        {...input}
        sort={{ field: 'id', order: 'DESC' }}
        record={record}
        setPayload={setPayload}
        payload={payload}
        optionLabel="name"
        optionValue="id"
        reference="users"
        setErrors={setErrors}
        errors={errors}
      />
    )
  }
  if (input.type === 'UrgenceSelect') {
    return (
      <UrgenceSelectInput
        {...input}
        record={record}
        setPayload={setPayload}
        payload={payload}
        setErrors={setErrors}
        errors={errors}
      />
    )
  }
  if (input.type === 'ThemeType') {
    return (
      <ThemeTypeInput
        {...input}
        record={record}
        setPayload={setPayload}
        payload={payload}
        setErrors={setErrors}
        errors={errors}
      />
    )
  }
  if (input.type === 'CoproprietairesReferenceFilteredCopro') {
    return (
      <ReferenceInput
        {...input}
        record={record}
        setPayload={setPayload}
        payload={payload}
        optionLabel="name"
        optionValue="id"
        reference="coproprietaires_frommonday"
        setErrors={setErrors}
        errors={errors}
      />
    )
  }
  if (input.type === 'Grade') {
    return (
      <GradeInput
        {...input}
        record={record}
        setPayload={setPayload}
        payload={payload}
        setErrors={setErrors}
        errors={errors}
      />
    )
  }
  if (input.type === 'ContractReferenceFilteredCopro') {
    return (
      <ReferenceInput
        {...input}
        record={record}
        setPayload={setPayload}
        payload={payload}
        optionLabel="contract_title"
        optionValue="id"
        reference="contracts_frommonday"
        setErrors={setErrors}
        errors={errors}
      />
    )
  }
  if (input.type === 'Type') {
    return (
      <TypeInput
        {...input}
        record={record}
        setPayload={setPayload}
        payload={payload}
        setErrors={setErrors}
        errors={errors}
      />
    )
  }
  if (input.type === 'time_type') {
    return (
      <TimePickerInput
        {...input}
        record={record}
        setPayload={setPayload}
        payload={payload}
        setErrors={setErrors}
        errors={errors}
      />
    )
  }
  return <div>Type de champ inconnu: {JSON.stringify(input)}</div>
}
export default HandlingInput
